import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IAction } from "reduxsauce";

import { Creators as AllCreators } from "../../../actions";
import { IState } from "../../reducer";
import { ICourse, IScormPackage } from "../../types/common";
import { FetchPartInstanceAnalytics, IUnitsAnalytics, IUser, IUsersAnalytics } from "../Common";
import CommonAnalytics from "../Main";
import {
  FetchAllUsersRequestState,
  FetchCourseDataRequestState,
  FetchScormPackageDataRequestState,
  FetchUsersAnalyticsRequestState,
} from "./reducer";

const Creators = (AllCreators as any).App.ScormPackageAnalytics;
const AppCreators = (AllCreators as any).App;

export interface IScormPackageAnalyticsOwnProps {
  courseId: string;
  objectId: string;
}

export interface IScormPackageAnalyticsStateProps {
  fetchAllUsersRequestState: FetchAllUsersRequestState;
  fetchScormPackageDataRequestState: FetchScormPackageDataRequestState;
  fetchCourseDataRequestState: FetchCourseDataRequestState;
  fetchUsersAnalyticsRequestState: FetchUsersAnalyticsRequestState;
  fetchClassDataRequestState: null;
  course: ICourse | null;
  scormPackage: IScormPackage | null;
  unitsAnalytics: IUnitsAnalytics[] | null;
  users: IUser[] | null;
  usersAnalytics: IUsersAnalytics | null;
  class: null;
  fetchPartInstanceAnalytics: FetchPartInstanceAnalytics;
}

export interface IScormPackageAnalyticsDispatchProps {
  mount: () => void;
  unmount: () => void;
  print: () => void;
}

export default connect<
  IScormPackageAnalyticsStateProps,
  IScormPackageAnalyticsDispatchProps,
  IScormPackageAnalyticsOwnProps,
  IState
>(
  (state: IState) => ({
    class: null,
    course: state.App.ScormPackageAnalytics._.course,
    fetchAllUsersRequestState: state.App.ScormPackageAnalytics._.fetchAllUsersRequestState,
    fetchClassDataRequestState: null,
    fetchCourseDataRequestState: state.App.ScormPackageAnalytics._.fetchCourseDataRequestState,
    fetchPartInstanceAnalytics: state.App.ScormPackageAnalytics._.fetchScormPackagePartInstSummaryRollup,
    fetchScormPackageDataRequestState: state.App.ScormPackageAnalytics._.fetchScormPackageDataRequestState,
    fetchUsersAnalyticsRequestState: state.App.ScormPackageAnalytics._.fetchUsersAnalyticsRequestState,
    location: state.router.location,
    scormPackage: state.App.ScormPackageAnalytics._.scormPackage,
    unitsAnalytics: state.App.ScormPackageAnalytics._.unitsAnalytics,
    users: state.App.ScormPackageAnalytics._.users,
    usersAnalytics: state.App.ScormPackageAnalytics._.usersAnalytics,
  }),
  (dispatch: Dispatch<IAction>, { courseId, objectId }: IScormPackageAnalyticsOwnProps) => ({
    mount: () => {
      dispatch(Creators.mount(courseId, objectId));
      dispatch(Creators.fetchCourseData(courseId));
      dispatch(Creators.fetchScormPackageData(objectId));
      dispatch(Creators.fetchAllUsers(courseId, objectId));
      dispatch(Creators.fetchUsersAnalytics(courseId, objectId));
    },
    print: () => dispatch(AppCreators.printCurrentPage()),
    unmount: () => dispatch(Creators.unmount(courseId, objectId)),
  })
)(CommonAnalytics);
